const PROFILE_FIELD = {
  EMAIL: "email",
  CITY: "city",
  ADDRESS: "address",
  MESSENGER: "messenger",
  MESSENGER_TYPE: "messenger_type",
  PHONE_NUMBER: "phone_number",
  LANGUAGE: "language",
  IS_AGREE_NEWS_LETTER: "is_agree_news_letter",
  VAT: "vat",
  LAST_NAME: "last_name",
  FIRST_NAME: "first_name",
  ACCOUNT_TYPE: "account_type",
  COMPANY_NAME: "company_name",
  BENEFICIARY_ID: "beneficiary_id",
  RESIDENCE_COUNTRY: "residence_country",
  TERMS_AND_CONDITIONS_OURS_AGREED_AT: "terms_and_conditions_ours_agreed_at",
  ROLES: "roles",
  IS_FEATURE_REQUEST_AVAILABLE: "is_feature_request_available",
  LINKED_PUBLISHER_ID: "notix_linked_publisher_id",
  PUB_TYPE: "pub_type",
};

export default PROFILE_FIELD;
